import { render, staticRenderFns } from "./DetailsExecution.vue?vue&type=template&id=36436aa6&scoped=true"
import script from "./DetailsExecution.vue?vue&type=script&lang=js"
export * from "./DetailsExecution.vue?vue&type=script&lang=js"
import style0 from "./DetailsExecution.vue?vue&type=style&index=0&id=36436aa6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36436aa6",
  null
  
)

export default component.exports